export default __webpack_public_path__ + "static/media/resilience.83dda650.png";